import axios from 'axios';
import { activateUserSession, isEmpty, isFormValid, setError } from '../../../../library/Core/SmartFunctions';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { axiosClient } from '../../../../library/Service/axiosClient';
import ScreenNavigationService, { AlumniProfileEditScreens } from '../../../../services/screen-navigation.service';
// import { toStudentEntity } from '../../../../services/student-mapper.service';
import StudentService from '../../../../services/student.service';
import { navigateToNextStep } from '../../services/profile-next-step-navigator';
import { primaryErrorKeysToIgnore, validateOnePrimaryCurrent } from '../primaryCurrentJob';
import { isValidIsCurrentAsPerWorkingStatus } from '../professional-work/ProfessionalWorkActions';
import { applyOutcomeLogic } from '../../../../library/Service/outcomeStatusByCurrentYear';

export const handleNext = (
    event: React.SyntheticEvent<HTMLButtonElement>,
    state: State,
    dispatch: (dispatchEvent: DispatchEvent) => void,
    globalState: any,
    globalDispatch: (dispatchEvent: DispatchEvent) => void,
    sessionState: any,
    sessionDispatch: (dispatchEvent: DispatchEvent) => void
) => {
    event.preventDefault();

    const isImpersonatedSession = sessionStorage.getItem('is-impersonated-session') === 'YES';
    const isFormValidState = isFormValid(state, dispatch, ['jobsApplied.*.companyId', 'entreprenurship.companyId', ...primaryErrorKeysToIgnore(state, 'entreprenurship')]);
    const customValidationPassed = isFormValidBasedOnCustomValidation(state, dispatch);
    const inValidDate = isValidDate(state, dispatch);

    if (!isImpersonatedSession && (!isFormValidState || !customValidationPassed || !inValidDate)) {
        dispatch({ type: 'SHOW_ERRORS' });
        return;
    }

    const entreprenurship = Array.isArray(state?.data['entreprenurship'])
        ? state.data['entreprenurship']
        : [state.data['entreprenurship']];

    const updatedEntreprenurship = entreprenurship.map((job) => {
        const existingJob = state?.data?.jobsList?.find((existingJob: any) => existingJob.id === job.id);
        const updatedJob = {
            ...job,
            recordTypeCode: existingJob?.recordTypeCode || job.recordTypeCode || 'JOINED',
            jobCategory: 'ENTREPRENEURSHIP',
            designation: isEmpty(job.designation) ? null : job.designation,
            seniorityLevelCode: isEmpty(job.seniorityLevelCode) ? null : job.seniorityLevelCode,
            founderStatus: isEmpty(job.founderStatus) ? null : job.founderStatus,
            endDate: job.isCurrent ? null : job.endDate,
            isPrimaryCurrent: job.isCurrent ? Boolean(job.isPrimaryCurrent) : false,
        };

        return updatedJob;
    });

    const jobsNotInEntreprenurship = state?.data?.jobsList?.filter((existingJob: any) =>
        !entreprenurship.some((job: any) => job.id === existingJob.id)
    );

    let jobHistory = [
        ...updatedEntreprenurship,
        ...jobsNotInEntreprenurship,
        ...state?.data?.jobsApplied || []
    ];

    jobHistory = jobHistory.map((job: any) => ({
        ...job,
        countryCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCountryCode : job.countryCode)?.trim() || null,
        cityCode: (job.isRemotelyWorking ? state?.data?.profile?.residingCityCode : job.cityCode)?.trim() || null
    }));

     //For checking is_current as per WorkingStatus
    const isValidIsCurrent = isValidIsCurrentAsPerWorkingStatus('entreprenurship.startDate',jobHistory,state, dispatch);
    if (!isValidIsCurrent) {
        dispatch({ type: 'SHOW_ERRORS' });
        return;
    }

    let updatedJobs = jobHistory;
    let updatedSelectedInstitute = state.data.selectedInstitute;
    let updatedUserInstitutes = state.data.userInstitutes;

    if (isEmpty(updatedSelectedInstitute?.postProgramCompletionStatusCode)) {
        const result = applyOutcomeLogic(jobHistory,updatedSelectedInstitute,"ENTREPRENEURSHIP",updatedUserInstitutes);
        updatedJobs = result.updatedJobs;
        updatedSelectedInstitute = result.updatedSelectedInstitute;
        updatedUserInstitutes = result.updatedUserInstitutes;

        dispatch({
            type: 'REFRESH_DATA',
            payload: {
                data: {
                    ...state.data,
                    entreprenurship: updatedJobs.filter(
                        j => j.jobCategory === 'ENTREPRENEURSHIP'
                    ),
                    selectedInstitute: updatedSelectedInstitute,
                    userInstitutes: updatedUserInstitutes,
                },
            },
        });
    }

    console.log("updatedJobs---", updatedJobs);
    // Send event to Moengage
    //sendMoEngageEvent(state?.data);

    StudentService.pageSave(
        state.routeInfo.id,
        state.routeInfo.pageName,
        StudentService.toStudentEntity({
            id: state.routeInfo.id,
            jobs: updatedJobs,
            profile: state?.data['profile'],
            userInstitutes: updatedUserInstitutes,
            selectedInstitute: updatedSelectedInstitute
        })
    ).then((response) => {
        if (response?.status === 200) {
            navigateToNextStep(AlumniProfileEditScreens.WORK_DETAILS, 
                {
                    ...state,
                    data: {
                        ...state.data,
                        selectedInstitute: updatedSelectedInstitute,
                        userInstitutes: updatedUserInstitutes,
                        jobs: updatedJobs
                    }
                },
                dispatch, sessionState, sessionDispatch);
        }
    });
};

const isFormValidBasedOnCustomValidation = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const errorMessages = [] as any[];
    let isFormInvalid = false;
    const jobs = state.data.jobsApplied;
    const entreprenurship = state.data.entreprenurship;

    if (isEmpty(entreprenurship?.companyId) && isEmpty(entreprenurship?.otherCompany)) {
        isFormInvalid = true;
        setError(`entreprenurship.companyId`, [`Please enter "Name of the Company"`], dispatch);
    } else {
        setError(`entreprenurship.companyId`, [], dispatch);
    }

    jobs.forEach((job: any, index: number) => {
        if (state?.data?.profile?.appliedForThePlacement) {
            if (isEmpty(job?.companyId) && isEmpty(job?.otherCompany)) {
                isFormInvalid = true;
                setError(`jobsApplied.${index}.companyId`, [`Please enter "Name of the Company"`], dispatch);
            } else {
                setError(`jobsApplied.${index}.companyId`, [], dispatch);
            }
        }else{
            setError(`jobsApplied.${index}.companyId`, [], dispatch); //clear error appliedForThePlacement set to false
        }
    });

    // Dispatch the validation errors to the state
    if ( isFormInvalid ) {
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'jobsApplied', errorMessages },
        });
        dispatch({
            type: 'SET_FIELD_VALIDATION_ERRORS',
            payload: { dataKey: 'entreprenurship', errorMessages },
        });
    }
    
    if (!validateOnePrimaryCurrent(state, dispatch, 'entreprenurship')) isFormInvalid = true;
    return !isFormInvalid;
};

export const onCurrentJobSelectionChange = (props: ControlOnChangeArguments) => {
    if(!props.state.data.entreprenurship?.isCurrent){
     setError(`entreprenurship.startDate`, [], props.dispatch);
     props.dispatch({ type: 'SET_FIELD_VALIDATION_ERRORS', payload: { dataKey: `${props.parentDataKey}.industryCode`, value: [] } });
    }
}
 
export const onEndDateChange = (props: ControlOnChangeArguments) => {
    const errorMessages =
        new Date(props.value) < new Date(props.row.startDate) ? ['End year should be greater than or equal to Start year'] : [];
    props.errorMessages.push(errorMessages);
};

export const handleCompleteLater = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:block');
};

const isValidDate = (state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    const job = state?.data['entreprenurship'];
    let isFormValid = true;

        if (isEmpty(job?.startDate)) {
            setError(`entreprenurship.startDate`, [`Please enter "Start Date" `], dispatch);
            isFormValid = false;
        } else {
            setError(`entreprenurship.startDate`, [], dispatch);
        }

        // if ((job?.isCurrent === false || isEmpty(job?.isCurrent)) && isEmpty(job?.endDate)) {
        //     setError(`entreprenurship.endDate`, [`Please enter "End Date" `], dispatch);
        //     isFormValid = false;
        // } else {
        //     setError(`entreprenurship.endDate`, [], dispatch);
        // }

        // if (new Date(job?.startDate) >= new Date(job?.endDate)) {
        //     console.log('Invalid date');
        // }
        // if (job?.isCurrent === false || isEmpty(job?.isCurrent)) {
        //     if (new Date(job?.startDate) > new Date(job?.endDate)) {
        //         setError(`entreprenurship.endDate`, [`End year should be greater than or equal to Start year`], dispatch);
        //         isFormValid = false;
        //     } else {
        //         setError(`entreprenurship.endDate`, [], dispatch);
        //     }
        // }

    return isFormValid;
};

const sendMoEngageEvent = async (user: any) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_MOENGAGE_API}/moengage/moengage-work-experience`, {
            userInfo: user,
        });
        // console.log('Response:', response.data);
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};
